import DepositOverdraftSettings from "@/models/Products/ProductSettings/DefaultSettings/Overdraft/DepositOverdraftSettings";
import CurrencyUtils from "@/lib/currencyUtils";

export default class UpdateDepositOverdraftSettingsRequest extends DepositOverdraftSettings {
    updatedAt: Date;

    public constructor(settings: DepositOverdraftSettings, updatedAt: Date, defaultWalletCurrency: string) {
        super();
        this.updatedAt = updatedAt;
        if (settings){
            this.overridable = settings.overridable;
            this.enabled = settings.enabled;
            this.hardLimit = settings.hardLimit;
            this.hardLimit.currency = defaultWalletCurrency;
            this.hardLimit.amount = CurrencyUtils.convertDecimalStringToAmountString(this.hardLimit.amount);
            this.softLimit = settings.softLimit;
            this.softLimit.currency = defaultWalletCurrency;
            this.softLimit.amount = CurrencyUtils.convertDecimalStringToAmountString(this.softLimit.amount);
        }
    }
}